import nBossConnection from 'modules/base/service/nBossConnection';
import EntityValidationResult from 'modules/base/dto/validation/EntityValidationResult';
import RuleBasedModelEditDto from '../dto/RuleBasedModelEditDto';

class RuleBasedModelEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'ruleBasedOutlierDetectorEditControl';
	}

	/**
	 * @return {Promise<RuleBasedModelEditDto>}
	 */
	create() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response => resolve(new RuleBasedModelEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {string} type
	 * @return {Promise<RuleBasedModelEditDto>}
	 */
	createByType(type) {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response =>
					resolve(
						new RuleBasedModelEditDto().setup({
							...response.data,
							type
						})
					)
				)
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<RuleBasedModelEditDto>}
	 */
	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new RuleBasedModelEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {RuleBasedModelEditDto} dto
	 * @return {Promise<EntityValidationResult>}
	 */
	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, {
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {RuleBasedModelEditDto} dto
	 * @return {Promise<EntityValidationResult>}
	 */
	update(id, dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}
}

export default new RuleBasedModelEditService();
